import { dollar, longDate } from 'src/utils/formats';

export const getDirectDebitDetailsFromApiResponse = (directDebitDetailsResponse) => ({
  monthlyAmount: dollar(directDebitDetailsResponse.amount),
  nextDebitDate: longDate(directDebitDetailsResponse.skipEnabled ? directDebitDetailsResponse.nextSkipDebitDate : directDebitDetailsResponse.nextDebitDate),
});
